import { createAuthenticatedGraphQLClient } from '../../auth/createAuthenticatedGraphQLClient';
import type { RuntimeEnvironment } from '../../graphql/config/runtimeConfig';
import type {
  RetryDeadPipelineJobMutation,
  RetryDeadPipelineJobMutationVariables,
} from '../../graphql/queries/retryDeadPipelineJob.generated';
import { RETRY_DEAD_PIPELINE_JOB_DOCUMENT } from '../canvassingSessionDocuments';

export type RetryDeadPipelineJobClientOverrides = {
  env: RuntimeEnvironment;
  fetchImpl?: Parameters<typeof createAuthenticatedGraphQLClient>[0]['fetchImpl'];
};

export const retryDeadPipelineJob = async (
  jobId: number,
  requestId: string,
  overrides: RetryDeadPipelineJobClientOverrides,
): Promise<RetryDeadPipelineJobMutation['retryDeadPipelineJob']> => {
  const client = createAuthenticatedGraphQLClient(overrides);
  const variables: RetryDeadPipelineJobMutationVariables = { jobId, requestId };
  const result = await client.request<RetryDeadPipelineJobMutation>({
    document: RETRY_DEAD_PIPELINE_JOB_DOCUMENT,
    variables,
  });

  return result.retryDeadPipelineJob;
};
